import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import FilterSection from '@app/src/pages/ResourceCollection/Filters/FilterSection'
import NegatableCategoryFilter from '@app/src/pages/ResourceCollection/Filters/NegatableCategoryFilter'
import type { Category, CategoryWithId } from '@app/src/types/categories'
import React from 'react'
import { useIntl } from 'react-intl'

interface CustomCategoriesFiltersProps {
  baseFilterName?: string
}

const CustomCategoriesFilters: React.FC<CustomCategoriesFiltersProps> = ({ baseFilterName }) => {
  const { formatMessage } = useIntl()
  const { data: categories } = useFetchResource<Category[]>({
    key: FetchKey.Category,
    endpoint: endpoints.category,
  })

  if (!categories || !categories?.length) {
    return null
  }

  const categoriesWithId = categories.filter((c): c is CategoryWithId => c.id != null)
  const filterName = `${baseFilterName ? `${baseFilterName}.` : ''}categoryOptions.id`

  return (
    <FilterSection defaultCollapsed label={formatMessage({ id: 'schemas.supplier.customCategories' })}>
      {categoriesWithId.map(category => (
        <NegatableCategoryFilter key={category.id} category={category} filterName={filterName} />
      ))}
    </FilterSection>
  )
}

export default CustomCategoriesFilters
